export class NetworkError extends Error {
    constructor(public fullMessage: string) {
        super(`Network Error`);
    }
}
